import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f4c3a878")

_pushScopeId("data-v-f4c3a878")
const _hoisted_1 = { class: "card d-flex flex-row h-100" }
const _hoisted_2 = { class: "d-flex flex-column flex-row-fluid w-100" }
const _hoisted_3 = { class: "card h-100" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "card-title w-75 mw-500px" }
const _hoisted_6 = { class: "\r\n                input-with-select\r\n                el-input\r\n                el-input-group\r\n                el-input-group--append\r\n                el-input-group--prepend\r\n              " }
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = { class: "\r\n            card-body card-scroll\r\n            h-200px\r\n            p-5\r\n            d-flex\r\n            flex-column\r\n            align-items-center\r\n          " }
const _hoisted_9 = { class: "fw-bolder" }
const _hoisted_10 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "badge badge-light-warning" }, " Recoger en sucursal ", -1)
const _hoisted_12 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "badge badge-light-primary" }, " Servicio a domicilio ", -1)
const _hoisted_14 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "badge badge-light-success" }, " Orden pagada en línea ", -1)
const _hoisted_16 = {
  key: 3,
  class: "mt-2"
}
const _hoisted_17 = { class: "badge badge-light-success" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "fw-bolder" }, "Total de la órden", -1)
const _hoisted_19 = { class: "" }
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "fw-bolder" }, "Pendiente", -1)
const _hoisted_22 = {
  key: 0,
  class: "text-success"
}
const _hoisted_23 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "fw-bolder" }, "Fecha de entrega", -1)
const _hoisted_25 = {
  key: 0,
  class: ""
}
const _hoisted_26 = { class: "badge badge-light-warning" }
const _hoisted_27 = {
  key: 1,
  class: ""
}
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "badge badge-light-primary" }, " ASAP ", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "fw-bolder" }, "Fecha de creación", -1)
const _hoisted_31 = { class: "" }
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "badge badge-light-primary" }
const _hoisted_34 = { class: "card-footer p-5 d-flex flex-column align-items-center" }
const _hoisted_35 = {
  key: 0,
  class: "w-100 mt-3"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("i", { class: "fas fa-paper-plane fs-4 me-2" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Enviar información ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_OrderDetailDrawer = _resolveComponent("OrderDetailDrawer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h3", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _withDirectives(_createVNode("input", {
                type: "text",
                autocomplete: "off",
                placeholder: "Buscar orden",
                class: "el-input__inner",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.context.searchString = $event)),
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.context.onSearchInput()))
              }, null, 544), [
                [_vModelText, _ctx.context.searchString]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_el_date_picker, {
              class: "me-5",
              modelValue: _ctx.context.filterDate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.context.filterDate = $event)),
              type: "daterange",
              "unlink-panels": "",
              "range-separator": "a",
              "start-placeholder": "Start date",
              "end-placeholder": "End date",
              clearable: false,
              shortcuts: _ctx.context.shortcuts,
              onChange: _ctx.context.loadActiveOrders
            }, null, 8, ["modelValue", "shortcuts", "onChange"]),
            _createVNode("button", {
              type: "button",
              class: "btn btn-sm btn-light",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.context.loadActiveOrders()))
            }, " Recargar ")
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_el_table, {
            style: {"width":"100%"},
            data: _ctx.context.orderList,
            "row-style": { cursor: 'pointer' },
            "empty-text": "Sin resultados",
            onRowClick: _ctx.context.onOrderClick,
            height: "100%"
          }, {
            default: _withId(() => [
              (_ctx.showSendControls)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    fixed: "",
                    label: "",
                    width: "50px"
                  }, {
                    default: _withId((scope) => [
                      _createVNode("div", {
                        class: "form-check form-check-custom form-check-solid",
                        onClick: _cache[6] || (_cache[6] = (ev) => ev.stopPropagation())
                      }, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          value: scope.row.OrderId,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.context.selectedOrders = $event))
                        }, null, 8, ["value"]), [
                          [_vModelCheckbox, _ctx.context.selectedOrders]
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_table_column, {
                fixed: "",
                prop: "OrderId",
                label: "ID",
                width: "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "OrderCheffId",
                label: "POS ID",
                width: "150"
              }),
              _createVNode(_component_el_table_column, {
                prop: "ClientName",
                label: "Cliente",
                "class-name": "fw-bolder",
                width: ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "BranchName",
                label: "Información",
                width: ""
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_9, _toDisplayString(scope.row.BranchName), 1),
                  (scope.row.OrderIsPickUp)
                    ? (_openBlock(), _createBlock("div", _hoisted_10, [
                        _hoisted_11
                      ]))
                    : _createCommentVNode("", true),
                  (!scope.row.OrderIsPickUp)
                    ? (_openBlock(), _createBlock("div", _hoisted_12, [
                        _hoisted_13
                      ]))
                    : _createCommentVNode("", true),
                  (!scope.row.OrderIsPickUp && scope.row.OrderPayId)
                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                        _hoisted_15
                      ]))
                    : _createCommentVNode("", true),
                  (!scope.row.OrderIsPickUp && !scope.row.OrderPayId)
                    ? (_openBlock(), _createBlock("div", _hoisted_16, [
                        _createVNode("span", _hoisted_17, _toDisplayString(scope.row.PaymentType?.PaymentTypeName), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "OrderTotal",
                label: "Total",
                width: ""
              }, {
                default: _withId((scope) => [
                  _hoisted_18,
                  _createVNode("div", _hoisted_19, " $" + _toDisplayString(scope.row.OrderTotal.toFixed(2)), 1),
                  _hoisted_20,
                  _hoisted_21,
                  (scope.row.OrderPayId)
                    ? (_openBlock(), _createBlock("div", _hoisted_22, " $" + _toDisplayString((0).toString(2)), 1))
                    : _createCommentVNode("", true),
                  (!scope.row.OrderPayId)
                    ? (_openBlock(), _createBlock("div", _hoisted_23, " $" + _toDisplayString(scope.row.OrderTotal.toFixed(2)), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "OrderStringPlaceDate",
                label: "Fecha"
              }, {
                default: _withId((scope) => [
                  _hoisted_24,
                  (scope.row.OrderScheduleDate)
                    ? (_openBlock(), _createBlock("div", _hoisted_25, [
                        _createVNode("span", _hoisted_26, _toDisplayString(_ctx.context.formatUtcString(scope.row.OrderScheduleDate, 'YYYY/MM/DD HH:mm')) + " - " + _toDisplayString(_ctx.context.formatUtcString(scope.row.OrderScheduleEndDate, 'HH:mm')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!scope.row.OrderScheduleDate)
                    ? (_openBlock(), _createBlock("div", _hoisted_27, [
                        _hoisted_28
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_29,
                  _hoisted_30,
                  _createVNode("div", _hoisted_31, _toDisplayString(_ctx.context.formatUtcString(scope.row.OrderStringPlaceDate, 'YYYY/MM/DD HH:mm')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "" }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_32, [
                    _createVNode("span", _hoisted_33, _toDisplayString(scope.row.OrderStatus?.OrderStatusName), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "onRowClick"])
        ]),
        _createVNode("div", _hoisted_34, [
          _createVNode(_component_el_pagination, {
            layout: "prev, pager, next",
            total: _ctx.context.orderCount,
            onCurrentChange: _ctx.context.onPageChange
          }, null, 8, ["total", "onCurrentChange"]),
          (_ctx.showSendControls)
            ? (_openBlock(), _createBlock("div", _hoisted_35, [
                _createVNode("button", {
                  class: "btn btn-lg btn-light-primary w-100",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.context.sendOrderInfo())),
                  disabled: _ctx.context.selectedOrders.length === 0 || _ctx.context.sendingRequest
                }, [
                  _hoisted_36,
                  _hoisted_37
                ], 8, ["disabled"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_OrderDetailDrawer, {
      order: _ctx.context.selectedOrder
    }, null, 8, ["order"])
  ]))
})